import { AvailableTurnos } from "../../../types/visitas";
import { getColorVisitDate } from "../../../utils/calendarUtils";

interface Props {
    fecha: string;
    horaInicio: string
    turno: AvailableTurnos;
}

export function VisitDate({ fecha, horaInicio, turno }: Props) {
    return (
        <div 
            className="rounded-md flex flex-col justify-center items-center p-3 border" 
            style={{ backgroundColor: getColorVisitDate(turno) }} >
            <p className="font-semibold">{fecha}</p>
            <p className="font-semibold text-sm">{horaInicio}</p>
        </div>
    );
}